/**
 * Custom Models Domain API Schemas
 *
 * Zod schemas for the Custom Models API domain
 */

import {
  CreateCustomModelBodySchema,
  CustomModelDeleteResponseSchema,
  CustomModelListResponseSchema,
  CustomModelPathVarsSchema,
  CustomModelReferencesResponseSchema,
  CustomModelResponseSchema,
  ReplaceAndDeleteBodySchema,
  UpdateCustomModelBodySchema
} from "./schemas";

export const ZCustomModels = {
  List: {
    method: "GET" as const,
    path: "/api/custom-models",
    Response: CustomModelListResponseSchema
  },
  Get: {
    method: "GET" as const,
    path: "/api/custom-models/:id",
    PathVars: CustomModelPathVarsSchema,
    Response: CustomModelResponseSchema
  },
  Create: {
    method: "POST" as const,
    path: "/api/custom-models",
    Body: CreateCustomModelBodySchema,
    Response: CustomModelResponseSchema
  },
  Update: {
    method: "PATCH" as const,
    path: "/api/custom-models/:id",
    PathVars: CustomModelPathVarsSchema,
    Body: UpdateCustomModelBodySchema,
    Response: CustomModelResponseSchema
  },
  References: {
    method: "GET" as const,
    path: "/api/custom-models/:id/references",
    PathVars: CustomModelPathVarsSchema,
    Response: CustomModelReferencesResponseSchema
  },
  ReplaceAndDelete: {
    method: "POST" as const,
    path: "/api/custom-models/:id/replace-and-delete",
    PathVars: CustomModelPathVarsSchema,
    Body: ReplaceAndDeleteBodySchema,
    Response: CustomModelDeleteResponseSchema
  },
  Delete: {
    method: "DELETE" as const,
    path: "/api/custom-models/:id",
    PathVars: CustomModelPathVarsSchema,
    Response: CustomModelDeleteResponseSchema
  }
} as const;
